var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8335 7H22.5835V0.75H10.0835V7H3.8335C2.11475 7 0.708496 8.40625 0.708496 10.125V60.125C0.708496 61.8438 2.11475 63.25 3.8335 63.25H28.8335C30.5522 63.25 31.9585 61.8438 31.9585 60.125V10.125C31.9585 8.40625 30.5522 7 28.8335 7ZM25.7085 38.25H19.4585V44.5H13.2085V38.25H6.9585V32H13.2085V25.75H19.4585V32H25.7085V38.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBattery);
export default __webpack_public_path__ + "static/media/iconBattery.108a341f4e505c0984d1eda141fe30af.svg";
export { ForwardRef as ReactComponent };